export const deleteProduct = /* GraphQL */ `
mutation  deleteProduct ($input:  deleteProduct!) {
    deleteProduct (input: $input) {
        id         
    }
}
`
